import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { LoadingService } from '../services/loading.service';

const SKIP_LOADING_HEADER = 'x-skip-loading';

@Injectable()
export class LoadingInterceptor implements HttpInterceptor {
  constructor(private loadingService: LoadingService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const skipLoading = request.headers.get(SKIP_LOADING_HEADER) === 'true';

    if (skipLoading) {
      const cleanRequest = request.clone({
        headers: request.headers.delete(SKIP_LOADING_HEADER),
      });
      return next.handle(cleanRequest);
    }

    this.loadingService.show();
    return next.handle(request).pipe(
      finalize(() => this.loadingService.hide())
    );
  }
}
